// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"112":"e6e6b6eb","145":"7394790e"}[chunkId] + ".css";
};